<template>
    <div class="carbis-footer">
        <div class="info-block">
            <a target="_blank" href="https://www.carbis.ru">ГК "Карбис"</a>
        </div>
        <div class="info-block">
            <a target="_blank" href="https://wiki.carbis.ru/external/%D0%B4%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BA%D0%B0">
            Powered by Carbis mini-Delivery
            </a>
        </div>
        <div class="info-block">
            <a target="_blank" href="https://dostavka.carbis.ru">Хочу себе!</a>
        </div>
    </div>    
</template>

<script>
export default {
    
}
</script>
